import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Login-Phone",
  "use": "icon-Login-Phone-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Login-Phone\">\r\n<rect x=\"7.75\" y=\"3.75\" width=\"14.5\" height=\"22.5\" rx=\"2.25\" stroke=\"#A9ADB5\" stroke-width=\"1.5\" />\r\n<rect x=\"12\" y=\"21\" width=\"6\" height=\"1.5\" fill=\"#A9ADB5\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol